module.exports = __webpack_public_path__ + "instagram-7f56c0ec.webp";